"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var Briefcase = function Briefcase(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2.default)({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M18.25 18.25H5.75c-.69 0-1.25-.56-1.25-1.25v-4.52a.478.478 0 01.745-.397A3.098 3.098 0 007 12.625h3.75v.651c0 .27.5.599 1.25.599s1.25-.329 1.25-.599v-.651H17c.626 0 1.238-.188 1.755-.542a.478.478 0 01.745.397V17c0 .69-.56 1.25-1.25 1.25zM17 12h-3.75v-.625a.312.312 0 00-.313-.313h-1.874a.312.312 0 00-.313.313V12H7a2.5 2.5 0 01-2.5-2.5V8.25C4.5 7.56 5.06 7 5.75 7h2.813v-.938c0-.862.7-1.562 1.562-1.562h3.75c.863 0 1.563.7 1.563 1.563V7h2.812c.69 0 1.25.56 1.25 1.25V9.5A2.5 2.5 0 0117 12zm-2.813-5.938a.312.312 0 00-.312-.312h-3.75a.313.313 0 00-.313.313V7h4.376v-.938z"
  }));
};

var _default = (0, _react.forwardRef)(Briefcase);

var _default2 = _default;
exports.default = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Briefcase, "Briefcase", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Briefcase.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Briefcase.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9JY29ucy9CcmllZmNhc2UudHN4Il0sIm5hbWVzIjpbIkJyaWVmY2FzZSIsInByb3BzIiwicmVmIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7QUFFQSxJQUFNQSxTQUF5RSxHQUFHLFNBQTVFQSxTQUE0RSxDQUFDQyxLQUFELEVBQVFDLEdBQVI7QUFBQSxTQUNoRjtBQUFLLElBQUEsS0FBSyxFQUFFLEVBQVo7QUFBZ0IsSUFBQSxNQUFNLEVBQUUsRUFBeEI7QUFBNEIsSUFBQSxPQUFPLEVBQUM7QUFBcEMsS0FBb0RELEtBQXBEO0FBQTJELElBQUEsR0FBRyxFQUFFQztBQUFoRSxNQUNFO0FBQ0UsSUFBQSxJQUFJLEVBQUMsY0FEUDtBQUVFLElBQUEsQ0FBQyxFQUFDO0FBRkosSUFERixDQURnRjtBQUFBLENBQWxGOztlQVNlLHVCQUFXRixTQUFYLEM7Ozs7Ozs7Ozs7Ozs7MEJBVFRBLFMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgUmVhY3QsIHsgZm9yd2FyZFJlZiwgUmVmRm9yd2FyZGluZ0NvbXBvbmVudCwgU1ZHUHJvcHMgfSBmcm9tICdyZWFjdCc7XG5cbmNvbnN0IEJyaWVmY2FzZTogUmVmRm9yd2FyZGluZ0NvbXBvbmVudDxTVkdTVkdFbGVtZW50LCBTVkdQcm9wczxTVkdTVkdFbGVtZW50Pj4gPSAocHJvcHMsIHJlZikgPT4gKFxuICA8c3ZnIHdpZHRoPXsyNH0gaGVpZ2h0PXsyNH0gdmlld0JveD1cIjAgMCAyNCAyNFwiIHsuLi5wcm9wc30gcmVmPXtyZWZ9PlxuICAgIDxwYXRoXG4gICAgICBmaWxsPVwiY3VycmVudENvbG9yXCJcbiAgICAgIGQ9XCJNMTguMjUgMTguMjVINS43NWMtLjY5IDAtMS4yNS0uNTYtMS4yNS0xLjI1di00LjUyYS40NzguNDc4IDAgMDEuNzQ1LS4zOTdBMy4wOTggMy4wOTggMCAwMDcgMTIuNjI1aDMuNzV2LjY1MWMwIC4yNy41LjU5OSAxLjI1LjU5OXMxLjI1LS4zMjkgMS4yNS0uNTk5di0uNjUxSDE3Yy42MjYgMCAxLjIzOC0uMTg4IDEuNzU1LS41NDJhLjQ3OC40NzggMCAwMS43NDUuMzk3VjE3YzAgLjY5LS41NiAxLjI1LTEuMjUgMS4yNXpNMTcgMTJoLTMuNzV2LS42MjVhLjMxMi4zMTIgMCAwMC0uMzEzLS4zMTNoLTEuODc0YS4zMTIuMzEyIDAgMDAtLjMxMy4zMTNWMTJIN2EyLjUgMi41IDAgMDEtMi41LTIuNVY4LjI1QzQuNSA3LjU2IDUuMDYgNyA1Ljc1IDdoMi44MTN2LS45MzhjMC0uODYyLjctMS41NjIgMS41NjItMS41NjJoMy43NWMuODYzIDAgMS41NjMuNyAxLjU2MyAxLjU2M1Y3aDIuODEyYy42OSAwIDEuMjUuNTYgMS4yNSAxLjI1VjkuNUEyLjUgMi41IDAgMDExNyAxMnptLTIuODEzLTUuOTM4YS4zMTIuMzEyIDAgMDAtLjMxMi0uMzEyaC0zLjc1YS4zMTMuMzEzIDAgMDAtLjMxMy4zMTNWN2g0LjM3NnYtLjkzOHpcIlxuICAgIC8+XG4gIDwvc3ZnPlxuKTtcblxuZXhwb3J0IGRlZmF1bHQgZm9yd2FyZFJlZihCcmllZmNhc2UpO1xuIl19